export default __webpack_public_path__ + "static/media/sports06.1d44b8b3.jpg";